import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-dialogo-consulta-declaracion-sugerida',
  templateUrl: './dialogo-cons-decla-sugerida.component.html',
  styleUrls: ['./dialogo-cons-decla-sugerida.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogoConsultaDeclaracionSugeridaComponent implements OnInit {
  constructor(
  	public dialogRef: MatDialogRef<DialogoConsultaDeclaracionSugeridaComponent>, 
    @Inject(MAT_DIALOG_DATA) private declaracionSugerida: any
  ) {  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/declaracion-sugerida/dialogo-cons-decla-sugerida/dialogo-cons-decla-sugerida.component.ts